import React, { useState } from "react";
import styles from "./Profile.module.scss";
import ProfileIcon from "../../../assets/icons/profile/ProfileIcon";
import MessageIcon from "../../../assets/icons/profile/MessageIcon";
import PasswordIcon from "../../../assets/icons/profile/PasswordIcon";
import GeoIcon from "../../../assets/icons/profile/GeoIcon";
import SecurityIcon from "../../../assets/icons/profile/SecurityIcon";
import VerificationIcon from "../../../assets/icons/profile/VerificationIcon";
import MainData from "../../../components/Profile/MainData/MainData";
import Warning from "../../../components/Warning/Warning";
import Contacts from "../../../components/Profile/Contacts/Contacts";
import Password from "../../../components/Profile/Password/Password";
import Verification from "../../../components/Profile/Verification/Verification";
import Location from "../../../components/Profile/Location/Location";
import Security from "../../../components/Profile/Security/Security";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../components/PrivateRoute/PrivateRoute";

const Profile = () => {
  const [activeSection, setActiveSection] = useState("main");
  const { t } = useTranslation();
  const { theme } = useTheme();

  const sections = [
    { id: "main", name: t("sections.main"), icon: <ProfileIcon /> },
    { id: "contacts", name: t("sections.contacts"), icon: <MessageIcon /> },
    // { id: "passwords", name: t("sections.passwords"), icon: <PasswordIcon /> },
    { id: "location", name: t("sections.location"), icon: <GeoIcon /> },
    { id: "security", name: t("sections.security"), icon: <SecurityIcon /> },
    // {
    //   id: "verification",
    //   name: t("sections.verification"),
    //   icon: <VerificationIcon />,
    // },
  ];

  const components = {
    main: <MainData />,
    contacts: <Contacts />,
    // passwords: <Password />,
    location: <Location />,
    security: <Security />,
    // verification: <Verification />,
  };

  return (
    <div className={styles.profile}>
      <h1 className={styles.title}>{t("pageProfileTitle")}</h1>
      <Warning />
      <div className={styles.profileSettings}>
        <aside className={styles.settingsNavigation}>
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`${styles.navigationButton} ${
                activeSection === section.id ? styles.activeButton : ""
              }`}
            >
              {React.cloneElement(section.icon, {
                color:
                  theme === "dark"
                    ? activeSection === section.id
                      ? "#0A61F5"
                      : "white"
                    : activeSection === section.id
                    ? "#0A61F5"
                    : "#000000",
              })}
              <span>{section.name}</span>
            </button>
          ))}
        </aside>

        <main>{components[activeSection] || null}</main>
      </div>
    </div>
  );
};

export default Profile;
